import { atom } from 'recoil'

export const showPopUnder = atom({
  key: 'showPopUnder',
  default: false,
})
